(function () {
  console.log("[Home Install] loaded");

  function getMainVariantId() {
    const form =
      document.querySelector('form[action^="/cart/add"]') ||
      document.querySelector('product-form form');

    if (!form) return null;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;

    return parseInt(idInput.value, 10) || null;
  }

  function getQty() {
    const qtyInput =
      document.querySelector('form[action^="/cart/add"] input[name="quantity"]') ||
      document.querySelector('product-form input[name="quantity"]');

    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return !qty || qty < 1 ? 1 : qty;
  }

  async function addBothToCart(mainVariantId, qty, installVariantId, productTitle) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        items: [
          { id: mainVariantId, quantity: qty },
          { id: installVariantId, quantity: 1, properties: { "_Installed for": productTitle || "" } }
        ]
      })
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || "Cart add failed");
    return data;
  }

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[data-home-install-btn]");
    if (!btn) return;

    console.log("[Home Install] clicked");

    const wrap = btn.closest("[data-home-install]");
    if (!wrap) return;

    const installVariantId = parseInt(wrap.getAttribute("data-install-variant-id"), 10);
    const productTitle = wrap.getAttribute("data-product-title") || "";

    const mainVariantId = getMainVariantId();
    const qty = getQty();

    if (!mainVariantId || !installVariantId) {
      console.error("[Home Install] Missing IDs", { mainVariantId, installVariantId });
      alert("Missing variant IDs. Check product form + metafield.");
      return;
    }

    try {
      btn.disabled = true;
      await addBothToCart(mainVariantId, qty, installVariantId, productTitle);
      window.location.href = "/cart";
    } catch (err) {
      console.error("[Home Install] Error:", err);
      alert(err.message || "Could not add installation service.");
    } finally {
      btn.disabled = false;
    }
  });
})();
